import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {CopilotMessageDto, CreateCopilotMessageBody} from './type'

class CopilotMessageServiceProvider extends ApiService {
  async getAll(conversationId: string): Promise<CopilotMessageDto[]> {
    return this.get<CopilotMessageDto[]>(`/copilot/conversation/${conversationId}/message`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async getById(conversationId: string, messageId: number): Promise<CopilotMessageDto> {
    return this.get<CopilotMessageDto>(`/copilot/conversation/${conversationId}/message/${messageId}`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async create(body: CreateCopilotMessageBody, conversationId: string): Promise<CopilotMessageDto> {
    return this.post<CopilotMessageDto>(`/copilot/conversation/${conversationId}/message`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const CopilotMessageService = new CopilotMessageServiceProvider()
